// Conversion factors for RTFO
// Converts metric to field
// Multiply metric value by the conversion factor to obtain the field value
export const rtfoConversionFactors = {
  pressure: 145.38,
  rate: 6.29,
  slurry: 6.29,
  clean: 6.29,
  producedRate: 6.29,
  proppant: 1 / 119.8,
  proppantBH: 1 / 119.8,
  fr: 1 / 119.8, // dfr conc
  fr2: 1, // lfr conc
  totalFr: 2.204,
  totalFr2: 0.264172,
  crossLinker: 1,
  gellant: 1 / 119.8,
  totalProppant: 2204,
  slurryVolume: 6.29,
  cleanVolume: 6.29,
  fracHeight: 3.28,
  halfLength: 3.28,
  xF: 3.28,
  fracArea: 3.28 * 3.28,
  depth: 3.28,
  casingDiameter: 1 / 25.4,
  vfr: 6.29,
  stageLength: 3.28,
  length: 3.28,
  clusterSpacing: 3.28,
  fluidIntensity: 6.29 / 3.28,
  sandPerFluid: 350.507,
  fluidPerSand: 0.00285301,
  frPerFluid: 1 / 119.8, 
  frPerFluid2: 1,
  frPerSand: 2.204 / 2204,
  frPerSand2: 0.264172 / 2204,
  tpm: 2204 / 3.28,
  tpRate: 0.00628981,
  rnp: 145.38 / 6.29,
  mfr: 2.204,
  perfDiameter: 0.0393701,
  rho: 1 / 119.8,
  kNwb: 6.29 / 145.038,
  frictionGradient: 145.38 / 3.28,
  fracGradient: 145.38 / 3.28,
  dPOverQPrime: 1 / (6.89476 * 6.28981),
  tonsPerMin: 2204,
  diffusivity: 3.28 * 3.28 / 6.29,
  dailyCleanVolumePerLength: 6.29 / 3.28,
  temperature: (tempC => tempC ? tempC * 9 / 5 + 32 : 0),
  fc: (plExp => 0.0442075 / Math.pow(6.29, plExp))
};